import { BaseProps } from "../BaseProps";
import { BaseHtmlProps } from "./getHtmlPropsFromBaseProps";

/**
 * Gets the BaseProps represented by the specified HTML component properties.
 * @param baseHtmlProps The standard HTML properties to get base properties for.
 * @returns The base properties.
 */
export function getBasePropsFromHtmlProps(baseHtmlProps: BaseHtmlProps): BaseProps {
  const { className, "data-testid": testId, style } = baseHtmlProps;

  return {
    ...(className !== undefined ? { className } : {}),
    ...(testId !== undefined ? { testId } : {}),
    ...(style !== undefined ? { style } : {}),
  };
}
